export const STATS_SET_TODAY = '[STATS] set today data';
export const STATS_SET_TOTAL_DURATION = '[STATS] set total stats duration';
export const STATS_SET_ALL_TIME = '[STATS] set read date for all time data';
export const STATS_SET_LOAD_IS_BUSY = '[STATS] set load is busy';
export const STATS_SET_LOAD_ERROR = '[STATS] set load error';
export const STATS_SET_DATA_DAYS = '[STATS] set data days';
export const STATS_SET_DATA_WEEKS = '[STATS] set data weeks';



// WEBPACK FOOTER //
// ./src/reading-stats/constants/ActionTypes.ts